import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useId from '@mui/utils/useId';
import { OutlinedFieldMenu } from '@/components/OutlinedFieldMenu';
import VehicleSelectFilter from '@/components/Vehilces/VehicleFilters/VehicleSelectFilter';
export interface MakeModelFilterProps {
  id?: string;
  label: string;
  availableMakes: string[];
  availableModels: string[];
  make: string;
  model: string;
  onMakeChange: (val: string) => void;
  onModelChange: (val: string) => void;
  emptyLabel?: string;
}
export function MakeModelFilter(t0) {
  const $ = _c(46);
  const {
    id,
    label,
    availableMakes,
    availableModels,
    make,
    model,
    onMakeChange,
    onModelChange,
    emptyLabel
  } = t0;
  const elId = useId(id || "vehicle-make-model-filter");
  const [open, setOpen] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function closeMenu() {
      setOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeMenu = t1;
  let t2;
  if ($[1] !== onMakeChange || $[2] !== onModelChange) {
    t2 = function resetValues() {
      onMakeChange("");
      onModelChange("");
      closeMenu();
    };
    $[1] = onMakeChange;
    $[2] = onModelChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const resetValues = t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpen(true);
    };
    t4 = () => {
      closeMenu();
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== emptyLabel || $[7] !== make || $[8] !== model) {
    t5 = () => {
      if (!make && !model) {
        return emptyLabel;
      }
      return `${make || "Make"} - ${model || "Model"}`;
    };
    $[6] = emptyLabel;
    $[7] = make;
    $[8] = model;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      mb: 2
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== label) {
    t7 = <Typography sx={t6}>{label}</Typography>;
    $[11] = label;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onMakeChange) {
    t8 = val => onMakeChange(val);
    $[13] = onMakeChange;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mb: 2
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== availableMakes || $[17] !== emptyLabel || $[18] !== make || $[19] !== t8) {
    t10 = <Grid size={6}><VehicleSelectFilter label="Make" showAll={true} options={availableMakes} value={make} onChange={t8} sx={t9} emptyLabel={emptyLabel} /></Grid>;
    $[16] = availableMakes;
    $[17] = emptyLabel;
    $[18] = make;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== onModelChange) {
    t11 = val_0 => onModelChange(val_0);
    $[21] = onModelChange;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = !make;
  let t13;
  if ($[23] !== availableModels || $[24] !== emptyLabel || $[25] !== model || $[26] !== t11 || $[27] !== t12) {
    t13 = <Grid size={6}><VehicleSelectFilter label="Model" showAll={true} options={availableModels} value={model} onChange={t11} disabled={t12} emptyLabel={emptyLabel} /></Grid>;
    $[23] = availableModels;
    $[24] = emptyLabel;
    $[25] = model;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t13) {
    t14 = <Grid container={true} spacing={2}>{t10}{t13}</Grid>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      mt: 2,
      display: "flex",
      justifyContent: "space-between",
      gap: 2
    };
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== resetValues) {
    t16 = <Button variant="outlined" onClick={resetValues}>Clear</Button>;
    $[33] = resetValues;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Button variant="contained" onClick={closeMenu}>View Results</Button>;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16) {
    t18 = <Box sx={t15}>{t16}{t17}</Box>;
    $[36] = t16;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== elId || $[39] !== label || $[40] !== open || $[41] !== t14 || $[42] !== t18 || $[43] !== t5 || $[44] !== t7) {
    t19 = <OutlinedFieldMenu id={elId} label={label} open={open} onOpen={t3} onClose={t4} renderValue={t5}>{t7}{t14}{t18}</OutlinedFieldMenu>;
    $[38] = elId;
    $[39] = label;
    $[40] = open;
    $[41] = t14;
    $[42] = t18;
    $[43] = t5;
    $[44] = t7;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}